import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LibraryAddCheckIcon(props: IconProps) {
    return <Icon {...props} iconKey={"library_add_check"}/>
}
